import { createAsyncThunk } from "@reduxjs/toolkit";
import companyApi from "api/companyApi";
import { formatQueryParams } from "helpers/format";

export const getCompanies = createAsyncThunk("Companies", async (params: any = {}) => {
  try {
    const response = await companyApi.companies(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
});

export const getCompany = async (id: string | number, params: any = {}) => {
  try {
    const response = await companyApi.getCompany(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postCompany = async (data: any = {}) => {
  try {
    const response = await companyApi.postCompany(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putCompany = async (id: string | number, data: any = {}) => {
  try {
    const response = await companyApi.putCompany(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getCompaniesByNormal = async (params: any = {}) => {
  try {
    const response = await companyApi.companies(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteCompany = async (id: string | number) => {
  try {
    const response = await companyApi.deleteCompany(id);
    return response;
  } catch (error) {
    return error;
  }
};